export interface Team {
  name: string;
  short: string;
  color: string;
}

export interface MatchEvent {
  minute: number;
  type: "goal" | "yellow" | "red" | "sub";
  side: "home" | "away";
  player: string;
}

export interface MatchStat {
  label: string;
  home: number;
  away: number;
}

export interface Match {
  id: string;
  leagueKey: string;
  leagueName: string;
  round: string;
  date: string;
  time: string;
  status: "live" | "upcoming" | "finished";
  minute?: number;
  score?: { home: number; away: number };
  home: Team;
  away: Team;
  venue: string;
  cover: string;
  events: MatchEvent[];
  stats: MatchStat[];
  hot?: boolean;
}

export const matches: Match[] = [
  {
    id: "m1",
    leagueKey: "premier-league",
    leagueName: "英超",
    round: "第 28 轮",
    date: "2026-10-15",
    time: "20:30",
    status: "live",
    minute: 63,
    score: { home: 2, away: 1 },
    home: { name: "曼城", short: "MCI", color: "#6CABDD" },
    away: { name: "利物浦", short: "LIV", color: "#C8102E" },
    venue: "伊蒂哈德球场",
    hot: true,
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20dramatic%20football%20stadium%20at%20night%20with%20bright%20floodlights%20and%20green%20pitch%2C%20blurred%20crowd%2C%20cinematic%20sport%20photography%20style%2C%20dark%20green%20tones%2C%20atmospheric%20mist&width=1280&height=720&seq=match-m1-01&orientation=landscape",
    events: [
      { minute: 12, type: "goal", side: "home", player: "哈兰德" },
      { minute: 34, type: "goal", side: "away", player: "萨拉赫" },
      { minute: 41, type: "yellow", side: "away", player: "麦卡利斯特" },
      { minute: 58, type: "goal", side: "home", player: "福登" },
    ],
    stats: [
      { label: "控球率", home: 58, away: 42 },
      { label: "射门", home: 14, away: 9 },
      { label: "射正", home: 6, away: 4 },
      { label: "角球", home: 7, away: 3 },
      { label: "犯规", home: 8, away: 12 },
      { label: "黄牌", home: 1, away: 3 },
    ],
  },
  {
    id: "m2",
    leagueKey: "la-liga",
    leagueName: "西甲",
    round: "第 26 轮",
    date: "2026-10-15",
    time: "22:00",
    status: "live",
    minute: 38,
    score: { home: 1, away: 1 },
    home: { name: "皇家马德里", short: "RMA", color: "#FEBE10" },
    away: { name: "巴塞罗那", short: "FCB", color: "#A50044" },
    venue: "伯纳乌球场",
    hot: true,
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20packed%20football%20stadium%20at%20dusk%20with%20golden%20light%20beams%20and%20green%20field%2C%20cinematic%20sport%20photography%20style%2C%20warm%20orange%20tones%2C%20atmospheric%20smoke&width=1280&height=720&seq=match-m2-01&orientation=landscape",
    events: [
      { minute: 9, type: "goal", side: "away", player: "莱万多夫斯基" },
      { minute: 27, type: "goal", side: "home", player: "维尼修斯" },
      { minute: 33, type: "yellow", side: "home", player: "楚阿梅尼" },
    ],
    stats: [
      { label: "控球率", home: 47, away: 53 },
      { label: "射门", home: 8, away: 10 },
      { label: "射正", home: 3, away: 5 },
      { label: "角球", home: 3, away: 5 },
      { label: "犯规", home: 9, away: 7 },
      { label: "黄牌", home: 2, away: 1 },
    ],
  },
  {
    id: "m3",
    leagueKey: "champions-league",
    leagueName: "欧冠",
    round: "16 强次回合",
    date: "2026-10-15",
    time: "03:00",
    status: "live",
    minute: 75,
    score: { home: 3, away: 2 },
    home: { name: "拜仁慕尼黑", short: "FCB", color: "#DC052D" },
    away: { name: "巴黎圣日耳曼", short: "PSG", color: "#004170" },
    venue: "安联球场",
    hot: true,
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20grand%20football%20stadium%20under%20bright%20spotlights%20with%20electric%20green%20pitch%2C%20cinematic%20sport%20photography%20style%2C%20deep%20emerald%20and%20gold%20tones%2C%20atmospheric%20haze&width=1280&height=720&seq=match-m3-01&orientation=landscape",
    events: [
      { minute: 18, type: "goal", side: "home", player: "凯恩" },
      { minute: 31, type: "goal", side: "away", player: "登贝莱" },
      { minute: 52, type: "goal", side: "home", player: "穆西亚拉" },
      { minute: 61, type: "red", side: "away", player: "阿什拉夫" },
      { minute: 68, type: "goal", side: "away", player: "巴尔科拉" },
      { minute: 73, type: "goal", side: "home", player: "凯恩" },
    ],
    stats: [
      { label: "控球率", home: 55, away: 45 },
      { label: "射门", home: 17, away: 11 },
      { label: "射正", home: 8, away: 5 },
      { label: "角球", home: 6, away: 4 },
      { label: "犯规", home: 10, away: 14 },
      { label: "红牌", home: 0, away: 1 },
    ],
  },
  {
    id: "m4",
    leagueKey: "premier-league",
    leagueName: "英超",
    round: "第 28 轮",
    date: "2026-10-15",
    time: "23:30",
    status: "upcoming",
    home: { name: "阿森纳", short: "ARS", color: "#EF0107" },
    away: { name: "切尔西", short: "CHE", color: "#034694" },
    venue: "酋长球场",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20empty%20football%20stadium%20pitch%20at%20night%20with%20soft%20floodlights%20and%20light%20fog%2C%20cinematic%20sport%20photography%20style%2C%20cool%20green%20tones%2C%20calm%20atmosphere&width=1280&height=720&seq=match-m4-01&orientation=landscape",
    events: [],
    stats: [],
  },
  {
    id: "m5",
    leagueKey: "csl",
    leagueName: "中超",
    round: "第 22 轮",
    date: "2026-10-15",
    time: "19:35",
    status: "upcoming",
    home: { name: "上海海港", short: "SIPG", color: "#E4002B" },
    away: { name: "山东泰山", short: "SDT", color: "#F58220" },
    venue: "浦东足球场",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20modern%20football%20stadium%20with%20evening%20lights%20and%20green%20field%2C%20cinematic%20sport%20photography%20style%2C%20teal%20and%20green%20tones%2C%20soft%20mist&width=1280&height=720&seq=match-m5-01&orientation=landscape",
    events: [],
    stats: [],
  },
  {
    id: "m6",
    leagueKey: "serie-a",
    leagueName: "意甲",
    round: "第 27 轮",
    date: "2026-10-16",
    time: "02:45",
    status: "upcoming",
    home: { name: "国际米兰", short: "INT", color: "#0068A8" },
    away: { name: "尤文图斯", short: "JUV", color: "#111111" },
    venue: "梅阿查球场",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20classic%20football%20stadium%20with%20warm%20amber%20floodlights%20and%20green%20pitch%2C%20cinematic%20sport%20photography%20style%2C%20dramatic%20atmosphere%2C%20soft%20smoke&width=1280&height=720&seq=match-m6-01&orientation=landscape",
    events: [],
    stats: [],
  },
  {
    id: "m7",
    leagueKey: "champions-league",
    leagueName: "欧冠",
    round: "16 强次回合",
    date: "2026-10-16",
    time: "04:00",
    status: "upcoming",
    home: { name: "皇家马德里", short: "RMA", color: "#FEBE10" },
    away: { name: "曼城", short: "MCI", color: "#6CABDD" },
    venue: "伯纳乌球场",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20grand%20football%20stadium%20night%20scene%20with%20dramatic%20spotlights%20and%20green%20pitch%2C%20cinematic%20sport%20photography%20style%2C%20deep%20green%20and%20gold%20tones%2C%20atmospheric%20mist&width=1280&height=720&seq=match-m7-01&orientation=landscape",
    events: [],
    stats: [],
  },
  {
    id: "m8",
    leagueKey: "premier-league",
    leagueName: "英超",
    round: "第 27 轮",
    date: "2026-10-14",
    time: "22:00",
    status: "finished",
    score: { home: 3, away: 0 },
    home: { name: "利物浦", short: "LIV", color: "#C8102E" },
    away: { name: "曼联", short: "MUN", color: "#DA291C" },
    venue: "安菲尔德球场",
    hot: true,
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20football%20stadium%20with%20red%20and%20green%20tones%20under%20night%20floodlights%2C%20cinematic%20sport%20photography%20style%2C%20atmospheric%20haze%2C%20dramatic%20contrast&width=1280&height=720&seq=match-m8-01&orientation=landscape",
    events: [
      { minute: 24, type: "goal", side: "home", player: "萨拉赫" },
      { minute: 56, type: "goal", side: "home", player: "努涅斯" },
      { minute: 81, type: "goal", side: "home", player: "若塔" },
    ],
    stats: [
      { label: "控球率", home: 61, away: 39 },
      { label: "射门", home: 18, away: 7 },
      { label: "射正", home: 9, away: 2 },
      { label: "角球", home: 8, away: 2 },
      { label: "犯规", home: 7, away: 13 },
      { label: "黄牌", home: 1, away: 4 },
    ],
  },
  {
    id: "m9",
    leagueKey: "la-liga",
    leagueName: "西甲",
    round: "第 25 轮",
    date: "2026-10-14",
    time: "23:15",
    status: "finished",
    score: { home: 2, away: 2 },
    home: { name: "马德里竞技", short: "ATM", color: "#CB3524" },
    away: { name: "塞维利亚", short: "SEV", color: "#D81920" },
    venue: "大都会球场",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20football%20stadium%20pitch%20at%20evening%20with%20warm%20lights%20and%20green%20grass%2C%20cinematic%20sport%20photography%20style%2C%20soft%20haze%2C%20harmonious%20tones&width=1280&height=720&seq=match-m9-01&orientation=landscape",
    events: [
      { minute: 22, type: "goal", side: "home", player: "格列兹曼" },
      { minute: 45, type: "goal", side: "away", player: "恩内斯里" },
      { minute: 67, type: "goal", side: "home", player: "莫拉塔" },
      { minute: 88, type: "goal", side: "away", player: "拉基蒂奇" },
    ],
    stats: [
      { label: "控球率", home: 52, away: 48 },
      { label: "射门", home: 13, away: 12 },
      { label: "射正", home: 6, away: 5 },
      { label: "角球", home: 5, away: 6 },
      { label: "犯规", home: 11, away: 10 },
      { label: "黄牌", home: 3, away: 2 },
    ],
  },
  {
    id: "m10",
    leagueKey: "csl",
    leagueName: "中超",
    round: "第 21 轮",
    date: "2026-10-14",
    time: "19:35",
    status: "finished",
    score: { home: 1, away: 0 },
    home: { name: "北京国安", short: "BGA", color: "#00954C" },
    away: { name: "上海申花", short: "SHS", color: "#005BAC" },
    venue: "工人体育场",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20modern%20football%20stadium%20with%20evening%20lights%20and%20green%20pitch%2C%20cinematic%20sport%20photography%20style%2C%20cool%20teal%20tones%2C%20soft%20mist&width=1280&height=720&seq=match-m10-01&orientation=landscape",
    events: [
      { minute: 39, type: "goal", side: "home", player: "张玉宁" },
      { minute: 72, type: "yellow", side: "away", player: "吴曦" },
    ],
    stats: [
      { label: "控球率", home: 49, away: 51 },
      { label: "射门", home: 11, away: 10 },
      { label: "射正", home: 4, away: 3 },
      { label: "角球", home: 4, away: 5 },
      { label: "犯规", home: 12, away: 9 },
      { label: "黄牌", home: 2, away: 1 },
    ],
  },
  {
    id: "m11",
    leagueKey: "premier-league",
    leagueName: "英超",
    round: "第 27 轮",
    date: "2026-10-13",
    time: "21:00",
    status: "finished",
    score: { home: 1, away: 1 },
    home: { name: "热刺", short: "TOT", color: "#132257" },
    away: { name: "纽卡斯尔", short: "NEW", color: "#241F20" },
    venue: "热刺球场",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20football%20stadium%20at%20night%20with%20white%20and%20green%20tones%20under%20floodlights%2C%20cinematic%20sport%20photography%20style%2C%20atmospheric%20haze&width=1280&height=720&seq=match-m11-01&orientation=landscape",
    events: [
      { minute: 33, type: "goal", side: "home", player: "孙兴慜" },
      { minute: 70, type: "goal", side: "away", player: "伊萨克" },
    ],
    stats: [
      { label: "控球率", home: 54, away: 46 },
      { label: "射门", home: 12, away: 11 },
      { label: "射正", home: 5, away: 4 },
      { label: "角球", home: 6, away: 4 },
      { label: "犯规", home: 10, away: 11 },
      { label: "黄牌", home: 2, away: 3 },
    ],
  },
  {
    id: "m12",
    leagueKey: "world-cup",
    leagueName: "世界杯",
    round: "小组赛 F 组",
    date: "2026-10-17",
    time: "03:00",
    status: "upcoming",
    home: { name: "阿根廷", short: "ARG", color: "#6CACE4" },
    away: { name: "巴西", short: "BRA", color: "#FFDF00" },
    venue: "卢赛尔体育场",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20grand%20stadium%20under%20golden%20spotlights%20with%20green%20pitch%20and%20soft%20confetti%2C%20cinematic%20sport%20photography%20style%2C%20festive%20warm%20tones%2C%20atmospheric%20glow&width=1280&height=720&seq=match-m12-01&orientation=landscape",
    events: [],
    stats: [],
  },
  {
    id: "m13",
    leagueKey: "champions-league",
    leagueName: "欧冠",
    round: "小组赛 E 组",
    date: "2026-10-13",
    time: "03:00",
    status: "finished",
    score: { home: 4, away: 1 },
    home: { name: "巴塞罗那", short: "FCB", color: "#A50044" },
    away: { name: "多特蒙德", short: "BVB", color: "#FDE100" },
    venue: "诺坎普球场",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20large%20football%20stadium%20at%20night%20with%20bright%20lights%20and%20green%20field%2C%20cinematic%20sport%20photography%20style%2C%20deep%20green%20tones%2C%20atmospheric%20haze&width=1280&height=720&seq=match-m13-01&orientation=landscape",
    events: [
      { minute: 15, type: "goal", side: "home", player: "亚马尔" },
      { minute: 28, type: "goal", side: "home", player: "莱万多夫斯基" },
      { minute: 54, type: "goal", side: "away", player: "阿德耶米" },
      { minute: 70, type: "goal", side: "home", player: "拉菲尼亚" },
      { minute: 86, type: "goal", side: "home", player: "费兰·托雷斯" },
    ],
    stats: [
      { label: "控球率", home: 63, away: 37 },
      { label: "射门", home: 20, away: 8 },
      { label: "射正", home: 10, away: 3 },
      { label: "角球", home: 9, away: 2 },
      { label: "犯规", home: 8, away: 12 },
      { label: "黄牌", home: 1, away: 3 },
    ],
  },
];

export const getMatchById = (id: string): Match | undefined =>
  matches.find((m) => m.id === id);